import { PursuitStageEnum } from "./Enums";

/**
 * This function handles the migration from old pursuit stage values ("researching", "connecting")
 * to "pitching" stage value for client storage
 */
export var migratePursuitStage = function migratePursuitStage(pursuitStage) {
  if (pursuitStage === "researching" || pursuitStage === "connecting") {
    return PursuitStageEnum.PITCHING.value;
  }
  return pursuitStage || "";
};